import { useEffect, useState } from "react";
import {
  MY_PROJECTS_GUIDE_DISMISS_EVENT,
  shouldShowMyProjectsGuide,
} from "~/utils/ui";

/**
 * 「我的项目」路径引导红点：无项目且本机未进入过 /profile/projects
 */
const useMyProjectsGuide = (user) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const update = () => setShow(shouldShowMyProjectsGuide(user));
    update();
    window.addEventListener(MY_PROJECTS_GUIDE_DISMISS_EVENT, update);
    return () =>
      window.removeEventListener(MY_PROJECTS_GUIDE_DISMISS_EVENT, update);
  }, [user]);

  return show;
};

export default useMyProjectsGuide;
